export const SMS_PROVIDERS = {
  NETGSM: "NETGSM",
  TWILIO: "TWILIO",
};

export const SMS_TYPES = {
  OTP: "OTP",
  STANDARD: "STANDARD",
};

export const PROVIDER_NOT_ACCEPTED_ERROR_CODES = {
  INVALID_MESSAGE_LENGTH: "INVALID_MESSAGE_LENGTH",
  INVALID_USERNAME_OR_PASSWORD: "INVALID_USERNAME_OR_PASSWORD",
  INVALID_SENDER_NAME: "INVALID_SENDER_NAME",
  INVALID_NUMBER: "INVALID_NUMBER",
  OTP_PACKAGE_NOT_FOUND: "OTP_PACKAGE_NOT_FOUND",
  INPUT_PARAMETER_ERROR: "INPUT_PARAMETER_ERROR",
  QUERY_LIMIT_EXCEEDED: "QUERY_LIMIT_EXCEEDED",
  SYSTEM_ERROR: "SYSTEM_ERROR",
  UNKNOWN: "UNKNOWN",
};

export const NET_GSM_OPERATORS_CODES = {
  10: "VODAFONE",
  20: "TURK_TELEKOM",
  30: "TURKCELL",
  40: "NETGSM_STH",
  41: "NETGSM_MOBIL",
  60: "TURKTELEKOM_SABIT",
  70: "TANIMSIZ_OPERATOR",
  160: "KKTC_VODAFONE",
  212: "YURTDISI",
  213: "YURTDISI",
  214: "YURTDISI",
  215: "YURTDISI",
  880: "KKTC_TURKCELL",
  UNKNOWN: "UNKNOWN",
};

export const SMS_STATUS_CALL_CODES = {
  SUCCESS: "SUCCESS",
  INVALID_AUTHENTICATION: "INVALID_AUTHENTICATION",
  NO_RECORD_FOUND: "NO_RECORD_FOUND",
  INVALID_QUERY: "INVALID_QUERY",
  QUERY_LIMIT_EXCEEDED: "QUERY_LIMIT_EXCEEDED",
  SYSTEM_ERROR: "SYSTEM_ERROR",
  UNKNOWN: "UNKNOWN",
};

export const SMS_STATUS_CODES = {
  QUEUED: "QUEUED",
  DELIVERED: "DELIVERED",
  TIMEOUT: "TIMEOUT",
  INVALID_NUMBER: "INVALID_NUMBER",
  OPERATOR_FAILED: "OPERATOR_FAILED",
  REJECTED_BY_OPERATOR: "REJECTED_BY_OPERATOR",
  SEND_ERROR: "SEND_ERROR",
  DUPLICATE: "DUPLICATE",
  BLACKLISTED: "BLACKLISTED",
  IYS_REJECTED: "IYS_REJECTED",
  IYS_ERROR: "IYS_ERROR",
  UNKNOWN: "UNKNOWN",
};

export const SMS_STATUS_ERROR_CODES = {
  UNDEFINED: undefined,
  UNKNOWN: "UNKNOWN",
  MESSAGE_BOX_FULL: "MESSAGE_BOX_FULL",
  OUT_OF_COVERAGE: "OUT_OF_COVERAGE",
  BUSY: "BUSY",
  LINE_NOT_ACTIVE: "LINE_NOT_ACTIVE",
  INVALID_NUMBER: "INVALID_NUMBER",
  BLACKLISTED: "BLACKLISTED",
  TIMEOUT: "TIMEOUT",
  SMS_DISABLED: "SMS_DISABLED",
  DEVICE_NOT_SUPPORTED: "DEVICE_NOT_SUPPORTED",
  FORWARDING_FAILED: "FORWARDING_FAILED",
  CALL_RESTRICTED: "CALL_RESTRICTED",
  UNIDENTIFIED_SUBSCRIBER: "UNIDENTIFIED_SUBSCRIBER",
  ILLEGAL_SUBSCRIBER: "ILLEGAL_SUBSCRIBER",
  SYSTEM_ERROR: "SYSTEM_ERROR",
};
